"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHotLoader = require("react-hot-loader");
var _classnames = _interopRequireDefault(require("classnames"));
var _Sidebar = _interopRequireDefault(require("./Sidebar"));
var _Main = _interopRequireDefault(require("./Main"));
var _Detail = _interopRequireDefault(require("./Detail"));
var styles = {
  "layout": "layout_2QJBLP",
  "components": "components_mOEPwo"
}; 
require('./Layout.css');
var Layout = function Layout(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className;
  var elements = _react.default.Children.toArray(children);
  var hasSidebar = elements.some(function (element) {
    return (0, _reactHotLoader.areComponentsEqual)(element.type, _Sidebar.default);
  });
  var hasDetail = elements.some(function (element) {
    return (0, _reactHotLoader.areComponentsEqual)(element.type, _Detail.default);
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(className, styles.layout)
  }, /*#__PURE__*/_react.default.createElement("main", {
    id: "main",
    className: styles.components,
    "data-test-id": "layout-components"
  }, elements.map(function (element) {
    return (0, _reactHotLoader.areComponentsEqual)(element.type, _Main.default) ? /*#__PURE__*/_react.default.cloneElement(element, {
      hasSidebar: hasSidebar,
      hasDetail: hasDetail
    }) : element;
  })));
};
var _default = exports.default = Layout;
//# sourceMappingURL=Layout.js.map